import { render, staticRenderFns } from "./DeliveryCompanyDialog.vue?vue&type=template&id=ba69df58"
import script from "./DeliveryCompanyDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryCompanyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports